import {
	createLucideIcon,
	Github,
	Linkedin,
	Twitter,
	Youtube,
	LayoutDashboard,
	Building2,
	Cloud,
	FileCode,
	LineChart,
	Eye,
	FastForward,
	Shield,
	Zap,
	Sparkles,
	Users,
	FileText,
	BookOpen,
	HelpCircle,
	Puzzle,
	CreditCard,
	FolderArchive,
	Handshake,
	File,
	Info,
	Newspaper,
	Briefcase,
	History,
	Mail,
	Store,
	Network,
	FileWarning,
	Scale,
	Image,
	RefreshCw,
	Code,
	ShoppingBag,
	PieChart,
	Megaphone,
	Grid,
	Globe,
	Bot,
	Folder,
	AudioWaveform,
	NotebookPen,
	Terminal,
	Pen,Hammer,MessageCircle,Coffee
} from "lucide-vue-next";

import { XIcon } from "@/lib/MyIcons.js";

const Npm = createLucideIcon("Npm", [
	[
		"path",
		{
			d: "M1.763 0C.786 0 0 .786 0 1.763v20.474C0 23.214.786 24 1.763 24h20.474c.977 0 1.763-.786 1.763-1.763V1.763C24 .786 23.214 0 22.237 0zM5.13 5.323l13.837.019-.009 13.836h-3.464l.01-10.382h-3.456L12.04 19.17H5.113z",
			stroke: "none",
			fill: "currentColor",
		},
	],
]);

const Discord = createLucideIcon("Discord", [
	[
		"path",
		{
			d: "M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z",
			stroke: "none",
			fill: "currentColor",
		},
	],
]);

const Threads = createLucideIcon("Threads", [
	[
		"path",
		{
			d: "M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L7.734 7.847c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.85 1.81-4.094 2.628-7.277 2.65Zm1.003-11.69c-.242 0-.487.007-.739.021-1.836.103-2.98.946-2.916 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.818-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221z",
			stroke: "none",
			fill: "currentColor",
		},
	],
]);

export const navigationItems = {
	Product: [

			{
			name: "Content folder",
			href: "/products/folder",
			icon: Folder, // LayoutDashboard,
			description: "Markdown content, on your computer ",
		},
	
	
		{
			name: "Publish",
			href: "/products/publish",
			icon: FastForward,
			description: "Deploy via Git. Host on the edge. Simplify content backups and previews ", // "Preview content changes before deploying them",
		},
	
		{
			name: "Editor Agent",
			href: "/products/editor-agent",
			icon: MessageCircle,//Code, //FileCode,
			description: "Create posts on autopilot, plan roadmaps, request edits, automate SEO ",//"Automate content creation with AI",
		},


	

			{
			name: "Images",
			href: "/products/images",
			icon: Image,
			description: " Generate images, optimize your photos, search your library using AI vision"//  Scalable hosting, Vision-based Fast-loading images and medias ",
		},	
		
		{
			name: "Modern SDK  ",
			href: "/products/sdk",
			icon: Code,//Hammer,
			description: "Build anything, fast. Connect AI agents, use the API, skip the boilerplate "//"Talk with your content, connect AI agents  ",
		},


			{
			name: "Websites  ",
			href: "/products/websites",
			icon: Store,//Globe,
			description: "Pick a template, or vibe-code custom apps from scratch ", // "Roll back to previous version of your content  ",
		},



/*
			{
			name: "Content API",
			href: "/products/api",
			icon: Code, //FileCode,
			description: "Simple + powerful API for your content",
		},
		
		{
			name: "MCP Server  ",
			href: "/products/mcp",
			icon: Bot,
			description: "Talk with your content, connect AI agents  ",
		},



		{
			name: "Enterprise",
			href: "/products/enterprise",
			icon: Building2,
			description: "Built for scaling businesses",
		},
*/

		/*
		{
			name: " File-based CMS",
			href: "/products/cms",
			icon: File, // LayoutDashboard,
			description: "Edit your content, your way",
		},
		{
			name: "Content API",
			href: "/products/api",
			icon: Code, //FileCode,
			description: "Simple + powerful API for your content",
		},
		{
			name: "Images",
			href: "/products/images",
			icon: Image,
			description: "Fast-loading images and medias ",
		},
		{
			name: "Previews",
			href: "/products/previews",
			icon: FastForward,
			description: "Preview content changes before deploying them",
		},
		{
			name: "Backups  ",
			href: "/products/backups",
			icon: RefreshCw,
			description: "Roll back to previous version of your content  ",
		},
		{
			name: "MCP Server  ",
			href: "/products/mcp",
			icon: Bot,
			description: "Talk with your content, connect AI agents  ",
		},
		{
			name: "Enterprise",
			href: "/products/enterprise",
			icon: Building2,
			description: "Built for scaling businesses",
		},*/
	],
	Solutions: [
		{
			name: "Indie Bloggers",
			href: "/solutions/indie-bloggers",
			icon: Coffee,
			description: "Write in Obsidian, deploy with Git",
			group: "By Audience",
		},
		{
			name: "WordPress Alternative",
			href: "/solutions/wordpress-alternative",
			icon: RefreshCw,
			description: "Modern CMS without the complexity",
			group: "By Migration",
		},
		{
			name: "Blogs",
			href: "/solutions/blogs",
			icon: Newspaper,
			description: "From personal notes to major publications",
			group: "Use Cases",
		},
		{
			name: "Marketing Sites",
			href: "/solutions/marketing",
			icon: Megaphone,
			description: "Portfolios and landing pages that convert",
			group: "Use Cases",
		},
		{
			name: "Team Wikis",
			href: "/solutions/wikis",
			icon: Users,
			description: "Company knowledge that evolves with you",
			group: "Use Cases",
		},

		/*
    {
      name: "Academic Research",
      href: "/solutions/academic",
      icon: BookOpen,
      description: "Organize and cite your research seamlessly",
      group: "Use Cases",
    },*/
		{
			name: "Vibe-coded Apps ",
			href: "/solutions/vibe-apps",
			icon: AudioWaveform, //BookOpen,
			description: "Build cool apps, keep the content separate",
			group: "Use Cases",
		},

		{
			name: "AI Content Hubs",
			href: "/solutions/ai-hubs",
			icon: Bot,
			description: "Feed knowledge to your AI assistants",
			group: "Use Cases",
		},

		/* AUDIENCES */
		{
			name: "Developers",
			href: "/solutions/developers",
			icon: Terminal,
			description: "Build faster with less code",
			description2: "Content that works with your workflow",
			group: "By Audience",
		},
		{
			name: "Writers",
			href: "/solutions/writers",
			icon: Pen,
			description: "Stop copy-pasting content into platforms",
			description2: "Write once, publish everywhere",
			group: "By Audience",
		},
	],
	Resources: [
		{
			name: "Docs",
			href: "/docs",
			icon: FileText,
			description: "Comprehensive documentation",
			hiddenNavbar: true,
		},
		{
			name: "Templates",
			href: "/templates",
			icon: File,
			description: "Ready-to-use project starters",
		},
		{
			name: "Themes",
			href: "/themes",
			icon: Grid,
			description: "Beautiful themes for your project",
		},
		{
			name: "Guides",
			href: "/guides",
			icon: BookOpen,
			description: "Step-by-step tutorials",
		},
		{
			name: "Blog",
			href: "/blog",
			icon: NotebookPen, //Newspaper,
			description: "Latest news and insights",
			hiddenFooter: true,
		},
		{
			name: "Help",
			href: "/help",
			icon: HelpCircle,
			description: "Find answers to your questions",
		},
		{
			name: "Pricing",
			href: "/pricing",
			icon: CreditCard,
			description: "Transparent pricing plans",
			hiddenNavbar: true,
		},
	],
	Company: [
		{
			name: "About",
			href: "/about",
			icon: Info,
			description: "Our mission and values",
		},
		{
			name: "Blog",
			href: "/blog",
			icon: Newspaper,
			description: "Latest news and insights",
		},
		{
			name: "Careers",
			href: "/careers",
			icon: Briefcase,
			description: "Join our talented team",
		},
		/*
    {
      name: "Changelog",
      href: "/company/changelog",
      icon: History,
      description: "Recent product updates",
    },*/
		{
			name: "Contact Us",
			href: "/contact",
			icon: Mail,
			description: "Get in touch with us",
		},
		/*
    {
      name: "Customers",
      href: "/company/customers",
      icon: Store,
      description: "Success stories",
    },
    {
      name: "Partners",
      href: "/company/partners",
      icon: Network,
      description: "Our trusted partners",
    },*/
		{
			name: "Privacy Policy",
			href: "/legal/privacy",
			icon: FileWarning,
			description: "How we protect your data",
		},
		{
			name: "Terms of Service",
			href: "/legal/terms",
			icon: Scale,
			description: "Terms and conditions",
		},
	],
	Social: [
		{
			name: "GitHub",
			href: "https://github.com/repo-md/repo-md",
			icon: Github,
			description: "View our open source projects",
		},

		// Npm
		{
			name: "npm",
			href: "https://www.npmjs.com/package/repo-md",
			icon: Npm,
			description: "npm i repo-md",
		},
		//Discord
		{
			name: "Discord",
			href: "https://repo.md/discord",
			icon: Discord,
			description: "Join our community",
		},

		/* 
    {
      name: "Threads",
      href: "https://www.threads.net/@repo_md",
      icon: Threads,
      description: "Follow us on Threads",
    },

    {
      name: "X",
      href: "https://x.com/repo_md",
      icon: XIcon,
      description: "Stay updated with latest news",
    },

    {
      name: "LinkedIn",
      href: "https://linkedin.com/company/repo-md",
      icon: Linkedin,
      description: "Follow our company page",
    },
    {
      name: "YouTube",
      href: "https://youtube.com/repo-md",
      icon: Youtube,
      description: "Watch tutorials and demos",
    },
     */
	],
};

// Top-level links that don't have dropdowns
export const topLevelLinks = [
	{ name: "Docs", href: "/docs" },
	{ name: "Pricing", href: "/pricing" },
];

export const hiddenSectionInNavbar = ["Social", "Company"]; //just show in foot + mobile menu
